<template>
  <div>
    <div v-if="template == 'default'">
      <div v-if="step == 'form'">
        <div class="form-group" v-bind:class="{ 'has-error': errors.message }">
          <label class="form-label" for="textareaProd">Необходимая продукция, объем, фасовка и пожелания</label>
          <textarea rows="2" class="form-control form-control--white" v-model="contact.message"></textarea>
          <p class="help-block" v-if="errors.message">
            {{ errors.message.join(', ') }}
          </p>
        </div>
        <div class="form-group" v-bind:class="{ 'has-error': errors.city }">
          <label class="form-label" for="inputCity">Город поставки</label>
          <input type="text" class="form-control form-control--white" v-model="contact.city">
          <p class="help-block" v-if="errors.city">
            {{ errors.city.join(', ') }}
          </p>
        </div>
        <div class="row gx-2">
          <div class="col-md-10">
            <div class="form-group" v-bind:class="{ 'has-error': errors.phone }">
              <label class="form-label" for="inputContact">Телефон</label>
              <input type="text" class="form-control form-control--white" v-model="contact.phone" v-mask="'+7(###)###-##-###'" placeholder="+7(xxx)xxx-xx-xx">
              <p class="help-block" v-if="errors.phone">
                {{ errors.phone.join(', ') }}</p>
            </div>
          </div>
          <div class="col-md-10">
            <div class="form-group" v-bind:class="{ 'has-error': errors.email }">
              <label class="form-label" for="inputContact">Email</label>
              <input type="text" class="form-control form-control--white" v-model="contact.email">
              <p class="help-block" v-if="errors.email">
                {{ errors.email.join(', ') }}</p>
            </div>
          </div>
        </div>
        <div class="form-bottom accept modal__accept">
          <button type="button" class="btn btn-primary accept-btn modal__accept-btn" v-on:click="sendForm">Отправить</button>
          <p class="accept-text">Отправляя вы принимаете <a href="/legal/">условия</a> обработки персональных данных</p>
        </div>
      </div>
      <div v-if="step == 'complete'">
        <p class="text-success">
          Ваше сообщение успешно отправлено! Мы свяжемся с Вами в ближайшее время.
        </p>
      </div>    
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueMask from 'v-mask'

import FormMixin from '../vue_mixins/FormMixin.vue'

Vue.use(VueMask)


export default {
  name: 'ContactForm',
  props: {
    theme: {
      type: String,
      default: 'Сообщение с формы'
    },
    template: {
      type: String,
      default: 'default'
    }
  },
  mixins: [FormMixin],
  components: {
  },
  data() {
      return {
          contact: {},
          errors: {},
          step: 'form',
          theme_message: this.theme
      }
      },
  mounted() {
      axios.get("/contacts/api/consult/").then(response => {
        this.contact = response.data
        if (!this.contact.phone) {
          this.contact.phone = '+7'
        }
      });
      },
  methods: {
      sendForm: function () {
          axios.put("/contacts/api/consult/", this.contact)
              .then(response => {
                  this.contact = response.data;
                  this.contact.theme_message = this.theme_message;
                  this.step = 'complete';
              })
              .catch(error => {
                  this.errors = error.response.data;
              });
      }
  }
}
</script>

<style lang="scss">
</style>
